import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getConferenceConfigurationAPI, getConferenceDetailsAPI, getConferenceDocumentsAPI, getConferenceSubscriptionAPI, getCountryListAPI, getKUConfigurationAPI, getKUPaperFeesmappingAPI } from "../../../services/conference-details-service";
import { ERROR_MESSAGE } from "../../../constants/constants";

const initialState = {
  conferenceDetails: undefined,
  countryList: [],
  conferenceFeesList : [],
  conferenceDocuments: [],
  kuConfiguration : undefined,
  conferenceConfiguration:undefined,
  kuPaperFeesMapping: undefined,
};

export const getConferenceDetails = createAsyncThunk(
  "conferenceDetails/getConferenceDetails",
  async (payload, thunkAPI) => {
    try {
      const resp = await getConferenceDetailsAPI(payload);
      if(resp?.registrationNumberPrefix === payload.registrationNumberPrefix){
        return resp;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(ERROR_MESSAGE.SOMETHING_WENT_WRONG);
    }
  }
);

export const getKUConfiguration = createAsyncThunk(
  "conferenceDetails/getKUConfiguration",
  async (thunkAPI) => {
    try {
      const resp = await getKUConfigurationAPI();

      return resp;
    } catch (error) {
      return thunkAPI.rejectWithValue(ERROR_MESSAGE.SOMETHING_WENT_WRONG);
    }
  }
);

export const getConferenceConfiguration = createAsyncThunk(
  "conferenceDetails/getConferenceConfiguration",
  async (payload, thunkAPI) => {
    try {
      return await getConferenceConfigurationAPI(payload);
    } catch (error) {
      return thunkAPI.rejectWithValue(ERROR_MESSAGE.SOMETHING_WENT_WRONG);
    }
  }
);

export const getKUPaperFeesMapping = createAsyncThunk(
  "conferenceDetails/getKUPaperFeesMapping",
  async (payload,thunkAPI) => {
    try {
      const resp = await getKUPaperFeesmappingAPI(payload);

      return resp;
    } catch (error) {
      return thunkAPI.rejectWithValue(ERROR_MESSAGE.SOMETHING_WENT_WRONG);
    }
  }
);

export const getCountryList = createAsyncThunk(
  "conferenceDetails/getCountryList",
  async (thunkAPI) => {
    try {
      const resp = await getCountryListAPI();

      return resp;
    } catch (error) {
      return thunkAPI.rejectWithValue(ERROR_MESSAGE.SOMETHING_WENT_WRONG);
    }
  }
);

export const getConferenceSubscription = createAsyncThunk(
  "conferenceDetails/getConferenceSubscription",
  async (payload, thunkAPI) => {
    try {
      const resp = await getConferenceSubscriptionAPI(payload);

      return resp;
    } catch (error) {
      return thunkAPI.rejectWithValue("something went wrong");
    }
  }
);

export const getConferenceDocuments = createAsyncThunk(
  "conferenceDetails/getConferenceDocuments",
  async (payload, thunkAPI) => {
    try {
      const resp = await getConferenceDocumentsAPI(payload);

      return resp;
    } catch (error) {
      return thunkAPI.rejectWithValue("something went wrong");
    }
  }
);

const conferenceDetailsSlice = createSlice({
  name: "conferenceDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getConferenceDetails.fulfilled, (state, action) => {
      state.conferenceDetails = action.payload;
    })
    .addCase(getCountryList.fulfilled, (state, action) => {
      state.countryList = action.payload;
    })
    .addCase(getConferenceSubscription.fulfilled, (state, action) => {
      state.conferenceFeesList = action.payload;
    })
    .addCase(getConferenceDocuments.fulfilled, (state, action) => {
      state.conferenceDocuments = action.payload;
    })
    .addCase(getKUConfiguration.fulfilled, (state, action) => {
      state.kuConfiguration = action.payload;
    })
    .addCase(getConferenceConfiguration.fulfilled, (state, action) => {
      state.conferenceConfiguration = action.payload;
    })
    .addCase(getKUPaperFeesMapping.fulfilled, (state,action) => {
      state.kuPaperFeesMapping = action.payload;
    });
  },
});

export default conferenceDetailsSlice.reducer;
